import React from 'react'
import { connectHits } from 'react-instantsearch-dom'

const Hit = ({ hit, components, setHighlight, showPopup, isMobile, version }) => (
  <components.CardWrapper
    onMouseEnter={() => setHighlight(hit)}
    onMouseLeave={() => setHighlight()}
    version={version}
  >
    <components.Card {...hit} showPopup={isMobile ? null : () => showPopup(hit)} version={version} />
  </components.CardWrapper>
)


const Hits = ({ hits, ...props }) =>
  hits.map(hit => <Hit key={hit.id} hit={hit} {...props} />)

export default connectHits(Hits)
